import React from "react";
import dayjs, { Dayjs } from "dayjs";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import "./TaskTimeline.css";

export interface TimelineRow {
  id: string | number;
  label: string;
  at: Dayjs;
  isPrayer: boolean;
  color: string;
  done: boolean;
}

interface Props {
  rows: TimelineRow[];
  onToggleDone: (id: number, checked: boolean) => void;
  onEdit?: (id: number) => void;
}

const TaskTimeline: React.FC<Props> = ({ rows, onToggleDone, onEdit }) => {
  return (
    <VerticalTimeline className="custom-timeline" lineColor="#333">
      {rows.map((it) => {
        const taskId = Number(String(it.id).split("-")[0]);

        return (
          <VerticalTimelineElement
            key={it.id}
            position={it.isPrayer ? "left" : "right"}
            className="custom-timeline-element"
            iconClassName="custom-timeline-icon"
            iconStyle={{
              background: it.done ? it.color : "#fff",
              border: `2px solid ${it.color}`,
            }}
            contentStyle={{
              background: it.isPrayer ? "#102010" : "#1b1b1b",
              borderLeft: `4px solid ${it.color}`,
              color: "#fff",
            }}
          >
            <div
              className={`tl-row ${it.isPrayer ? "prayer" : "task"}`}
              onClick={
                !it.isPrayer && onEdit ? () => onEdit(taskId) : undefined
              }
            >
              {it.isPrayer ? (
                <>
                  <strong>{it.label}</strong>
                  <span className="tl-time">{it.at.format("HH:mm")}</span>
                </>
              ) : (
                <>
                  <span className="tl-time">{it.at.format("HH:mm")}</span>
                  <strong>{it.label}</strong>

                  <input
                    type="checkbox"
                    checked={it.done}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => onToggleDone(taskId, e.target.checked)}
                  />
                </>
              )}
            </div>
          </VerticalTimelineElement>
        );
      })}
    </VerticalTimeline>
  );
};

export default TaskTimeline;
